<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-click-outside="closeModal">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>

          <div class="text-center modal-body">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  methods: {
    closeModal: function() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.md-dialog {
  &.dark {
    .md-dialog-container {
      background-color: #23222f;
      color: white;
    }
  }
}

.modal-mask {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
  display: table;
  transition: opacity 0.15s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.picture {
  max-width: 150px;

  img {
    border-radius: 6px;
  }
}

.modal-title {
  margin: 0;
  line-height: 1.5;
}

.modal-body {
  padding: 24px 24px 16px;
  max-height: calc(90vh - 160px);
  overflow-y: auto;

  p {
    margin-top: 0;
  }
}

.modal-container {
  max-width: 900px;
  margin: 16px;
  position: relative;
  background-color: #1b193c;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  border: none;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 24px 12px;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;

  .md-button .md-button-content i {
    font-size: 16px !important;
    opacity: 0.5;

    &:hover,
    &:focus {
      opacity: 1;
    }
  }
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px;
  padding-top: 0;

  .md-button {
    .md-ripple {
      padding-left: 16px !important;
      padding-right: 16px !important;
      width: auto;
    }
  }
}

.notice-modal + .modal-mask .modal-footer,
.small-alert-modal + .modal-mask .modal-footer {
  justify-content: center;
}

.instruction {
  margin-bottom: 25px;
}

.small-alert-modal + .modal-mask .modal-container {
  width: 300px;
  margin: 0 auto;

  .modal-body {
    margin-top: 20px;
  }
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-default-button {
  position: absolute !important;
  right: 9px;
  top: 12px;
}
.modal-mask > .md-layout {
  padding: 40px 0;
  height: 100vh;
  overflow: auto;
}
</style>
